<template>
  <div>
    <div class="row">
      <div class="col-8 d-flex align-items-center py-1 d-flex align-items-center"
           style="min-height: 40px;padding-left: 18px;">
        <p class="subtask-title w-100 m-0" @click="editSubtaskTitle" v-if="!editingSubtaskTitle">{{ subtask.title }}</p>
        <input
            v-else
            ref="subtaskTitleInput"
            type="text"
            class="form-control"
            placeholder="Enter subtask title"
            v-model="subtaskTitle"
            @keyup.esc="stopEditingSubtask"
            @keyup.enter="saveChanges"
        />
      </div>
      <div
          class="col d-flex align-items-center justify-content-end"
          v-html="checkboxIcon()"
          @click="markSubtaskAsDone"
      ></div>
    </div>
    <div class="row" v-if="editingSubtaskTitle">
      <div class="col text-right" v-if="showDeleteConfirmation">
        <button
            type="button"
            class="btn wfh-btn-primary-outline"
            style="min-height: auto;width: auto;height: 32px;padding: 0 8px !important;"
            @click="showDeleteConfirmation = false"
        >
          Cancel
        </button>
        <button
            type="button"
            class="btn wfh-btn-primary"
            style="min-height: auto;width: auto;height: 32px;padding: 0 8px !important;"
            @click="deleteSubtask"
        >
          Confirm
        </button>
      </div>
      <div class="col text-right" v-else>
        <button type="button" class="icon-btn" @click="promptDeleteConfirmation">
          <img src="/images/delete.svg" alt="Delete subtask">
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    subtask: {
      required: true,
    },
    editable: {
      type: Boolean,
      required: true,
    },
  },

  data () {
    return {
      editingSubtaskTitle: false,
      subtaskTitle: this.subtask.title,
      showDeleteConfirmation: false,
    };
  },

  methods: {
    checkboxIcon () {
      return this.subtask.completed_at ?
          `<img ${this.editable ? 'style="cursor: pointer;"' : ''} src="/images/Icon-1.svg" alt="">` :
          `<img ${this.editable ? 'style="cursor: pointer;"' : ''} src="/images/State.png" alt="">`;
    },

    editSubtaskTitle () {
      if (this.editable) {
        this.editingSubtaskTitle = true;

        this.$nextTick(() => {
          this.$refs['subtaskTitleInput'].focus();
        });
      }
    },

    async saveChanges () {
      const res = await axios.put(`/tasks/${this.subtask.id}`, {
        title: this.subtaskTitle,
      });

      this.subtask.title = res.data.data.title;
      this.stopEditingSubtask();
    },

    async markSubtaskAsDone () {
      if (this.editable) {
        const res = await axios.put(`/tasks/${this.subtask.id}`, {
          completed: this.subtask.completed_at == null,
        });

        this.subtask.completed_at = res.data.data.completed_at;
      }
    },

    promptDeleteConfirmation () {
      this.showDeleteConfirmation = true;
    },

    deleteSubtask () {
      this.$emit('deleteSubtask', this.subtask.id);
      this.stopEditingSubtask();
    },

    stopEditingSubtask () {
      this.subtaskTitle = this.subtask.title;
      this.editingSubtaskTitle = false;
    },
  },
};
</script>

<style scoped lang="scss">
.subtask-title {
  color: #303030;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
  font-weight: 400;
}

.icon-btn {
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  outline: none;
}
</style>
